import { render, staticRenderFns } from "./business-center.vue?vue&type=template&id=3c2f80fe&scoped=true&"
import script from "./business-center.vue?vue&type=script&lang=js&"
export * from "./business-center.vue?vue&type=script&lang=js&"
import style0 from "./business-center.vue?vue&type=style&index=0&id=3c2f80fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f80fe",
  null
  
)

export default component.exports